import Batch from "../../api/Formulations/Batch";

const smeStatuses = ["Submitted", "Assigned", "InProgress", "OnHold", "Needs Review", "Draft"];
const formulatorStatuses = ["Submitted", "OnHold", "Needs Review", "Draft"];

const normalizeStatus = (status) => (status ?? "").replace(/\s+/g, "").toUpperCase();

export function isBatchAssignedToUser(batch, username) {
  return !!(
    batch &&
    batch.preparedByEmail &&
    username &&
    batch.preparedByEmail.toLowerCase() === username.toLowerCase()
  );
}

export function canCancelBatchForUser(batch, username, isBlendSME, isBlendFormulator) {
  if (!batch) return false;
  const batchStatus = normalizeStatus(batch.batchStatusName);

  if (isBatchAssignedToUser(batch, username)) {
    return true;
  }

  if (isBlendSME && smeStatuses.some((status) => normalizeStatus(status) === batchStatus)) {
    return true;
  }

  if (
    isBlendFormulator &&
    formulatorStatuses.some((status) => normalizeStatus(status) === batchStatus)
  ) {
    return true;
  }

  return false;
}

export async function cancelBatchWithAssignedOverride(batch, cancelReason) {
  if (!batch || !batch.id) {
    return { message: "Batch not found." };
  }

  return Batch.updateBatchStatus(batch.id, "Cancelled", cancelReason);
}
